// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bg-green[data-v-003cd308]{background:linear-gradient(90deg,#1193a7,#31bb38)!important}@media (max-width:500px){.data-text[data-v-003cd308]{align-items:center}.data-text-wrapper[data-v-003cd308]{padding:10px 0}}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
